export default __webpack_public_path__ + "static/intelligent-automation-1-54b55affad8eb27a491783fdb283a98b.webp";